import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCheck as fasCheck,
  faCut as fasCut,
  faMinus as fasMinus,
  faSearchPlus as fasSearchPlus,
  faAngleDown as fasAngleDown,
  faAngleUp as fasAngleUp,
  faUserCheck as fasUserCheck,
  faPlus as fasPlus,
  faChevronLeft as fasChevronLeft,
  faReply as fasReply,
  faSearch as fasSearch,
  faCameraAlt as fasCameraAlt,
  faHomeLgAlt as fasHomeLgAlt,
  faShoppingBag as fasShoppingBag,
  faCartArrowDown as fasCartArrowDown,
  faPhoneAlt as fasPhoneAlt,
  faCheckCircle as fasCheckCircle,
  faUserCrown as fasUserCrown,
  faPhotoVideo as fasPhotoVideo,
  faStar as fasStar,
  faSlidersH as fasSlidersH,
  faAngleLeft as fasAngleLeft,
  faArrowRight as fasArrowRight,
  faShoppingBasket as fasShoppingBasket,
  faTimes as fasTimes,
  faCar as fasCar,
  faTruck as fasTruck,
  faMotorcycle as fasMotorcycle,
  faTractor as fasTractor,
  faTruckMonster as fasTruckMonster,
  faBicycle as fasBicycle,
  faExclamation as fasExclamation,
  faExclamationTriangle as fasExclamationTriangle,
  faPlay as fasPlay,
  faExclamationCircle as fasExclamationCircle,
  faClock as fasClock,
  faChevronCircleRight as fasChevronCircleRight,
  faHeart as fasHeart,
  faBadgeCheck as fasBadgeCheck,
  faBuilding as fasBuilding,
  faBriefcase as fasBriefcase,
  faMapMarkerAlt as fasMapMarkerAlt,
  faFileAlt as fasFileAlt,
  faReceipt as fasReceipt,
  faCalendar as fasCalendar,
  faCrown as fasCrown,
  faEuroSign as fasEuroSign,
  faFileInvoice as fasFileInvoice,
  faTags as fasTags,
  faPercentage as fasPercentage,
  faHeadset as fasHeadset,
  faMapMarkedAlt as fasMapMarkedAlt,
  faBullhorn as fasBullhorn,
  faEllipsisH as fasEllipsisH,
  faUsers as fasUsers,
  faWrench as fasWrench,
  faChevronRight as fasChevronRight,
  faTrashAlt as fasTrashAlt,
  faIdCard as fasIdCard,
  faChevronUp as fasChevronUp,
  faChevronDown as fasChevronDown,
  faLink as fasLink,
  faShareAlt as fasShareAlt,
  faLongArrowAltLeft as fasLongArrowAltLeft,
  faExchangeAlt as fasExchangeAlt,
  faCog as fasCog,
  faWallet as fasWallet,
  faCoins as fasCoins,
  faImage as fasImage,
  faMobileAlt as fasMobileAlt,
  faTag as fasTag,
  faShoppingCart as fasShoppingCart,
  faLightbulb as fasLightbulb,
  faCircle as fasCircle,
  faBell as fasBell,
  faTimesCircle as fasTimesCircle,
  faBrowser as fasBrowser,
  faArrowAltCircleRight as fasArrowAltCircleRight,
  faDownload as fasDownload,
  faInfoCircle as fasInfoCircle,
  faLockAlt as fasLockAlt,
  faCommentsAlt as fasCommentsAlt,
  faUserHeadset as fasUserHeadset,
  faTruckLoading as fasTruckLoading,
  faTrash as fasTrash,
  faPencil as fasPencil,
  faMapMarkerCheck as fasMapMarkerCheck,
  faMapMarkerQuestion as fasMapMarkerQuestion,
  faEnvelope as fasEnvelope,
  faEnvelopeOpen as fasEnvelopeOpen,
  faArrowCircleUp as fasArrowCircleUp,
  faCalendarTimes as fasCalendarTimes,
  faBox as fasBox,
  faPercent as fasPercent,
  faSave as fasSave,
  faSpinner as fasSpinner,
  faCartPlus as fasCartPlus,
  faSlidersV as fasSlidersV,
  faInfoSquare as fasInfoSquare,
  faCopy as fasCopy,
  faCogs as fasCogs,
  faBoxFull as fasBoxFull,
  faPaperPlane as fasPaperPlane,
  faCreditCardFront as fasCreditCardFront,
  faShippingFast as fasShippingFast,
  faCommentAlt as fasCommentAlt,
  faPaperclip as fasPaperclip,
  faToolbox as fasToolbox,
  faLock as fasLock,
  faRepeat as fasRepeat,
  faTrophyAlt as fasTrophyAlt,
  faGarageOpen as fasGarageOpen,
  faFileSignature as fasFileSignature,
  faAngleRight as fasAngleRight,
  faLocation as fasLocation,
  faClone as fasClone,
  faClipboardList as fasClipboardList,
  faFilePdf as fasFilePdf,
  faEye as fasEye,
  faFileInvoiceDollar as fasFileInvoiceDollar,
  faUndo as fasUndo,
  faList as fasList,
  faMap as fasMap,
  faPhone as fasPhone,
  faTh as fasTh,
  faLocationArrow as fasLocationArrow,
  faArrowUp as fasArrowUp,
  faChartLine as fasChartLine,
  faWarehouse as fasWarehouse,
  faArrowLeft as fasArrowLeft,
  faRedo as fasRedo,
  faFile as fasFile,
  faBolt as fasBolt,
  faLightbulbOn as fasLightbulbOn,
  faThumbtack as fasThumbtack,
  faUnlink as fasUnlink,
  faVolumeUp as fasVolumeUp,
  faVolumeMute as fasVolumeMute,
} from '@aurionsarl/fontawesome-pro-solid-svg-icons'
import {
  faTrophyAlt as falTrophyAlt,
  faTimes as falTimes,
  faBolt as falBolt,
  faBell as falBell,
  faSearchPlus as falSearchPlus,
  faPlus as falPlus,
  faCircle as falCircle,
  faMinus as falMinus,
  faPlayCircle as falPlayCircle,
  faAngleLeft as falAngleLeft,
  faAngleRight as falAngleRight,
  faArrowLeft as falArrowLeft,
  faLongArrowLeft as falLongArrowLeft,
  faChevronRight as falChevronRight,
  faUndo as falUndo,
  faQuestionCircle as falQuestionCircle,
  faAngleDown as falAngleDown,
  faAngleUp as falAngleUp,
  faShippingFast as falShippingFast,
  faChevronLeft as falChevronLeft,
  faChevronDown as falChevronDown,
  faCheck as falCheck,
  faBars as falBars,
  faLock as falLock,
  faShieldCheck as falShieldCheck,
  faMotorcycle as falMotorcycle,
  faTools as falTools,
  faUserCheck as falUserCheck,
  faUserCircle as falUserCircle,
  faSearch as falSearch,
  faShoppingBag as falShoppingBag,
  faStore as falStore,
  faUniversity as falUniversity,
  faImage as falImage,
  faPercentage as falPercentage,
  faRedoAlt as falRedoAlt,
  faPlusCircle as falPlusCircle,
  faMinusCircle as falMinusCircle,
  faExternalLink as falExternalLink,
  faLifeRing as falLifeRing,
  faInfoCircle as falInfoCircle,
  faPencil as falPencil,
  faExclamationTriangle as falExclamationTriangle,
  faHandPointDown as falHandPointDown,
  faHeart as falHeart,
  faPlay as falPlay,
  faTruck as falTruck,
  faTractor as falTractor,
  faLightbulbOn as falLightbulbOn,
  faLightbulb as falLightbulb,
  faLightbulbSlash as falLightbulbSlash,
  faCar as falCar,
  faExternalLinkAlt as falExternalLinkAlt,
  faCarSide as falCarSide,
  faCalendarAlt as falCalendarAlt,
  faClock as falClock,
  faSlidersH as falSlidersH,
  faSortAmountDown as falSortAmountDown,
  faThLarge as falThLarge,
  faListUl as falListUl,
  faEraser as falEraser,
} from '@aurionsarl/fontawesome-pro-light-svg-icons'
import {
  faUserCrown as fadUserCrown,
  faCheckCircle as fadCheckCircle,
  faExclamationTriangle as fadExclamationTriangle,
} from '@aurionsarl/fontawesome-pro-duotone-svg-icons'
import {
  faFacebookSquare as fabFacebookSquare,
  faFacebookF as fabFacebookF,
  faInstagram as fabInstagram,
  faPaypal as fabPaypal,
  faGoogle as fabGoogle,
  faCcVisa as fabCcVisa,
  faCcPaypal as fabCcPaypal,
  faCcMastercard as fabCcMastercard,
  faCcApplePay as fabCcApplePay,
  faTiktok as fabTiktok,
  faYoutube as fabYoutube,
  faTwitter as fabTwitter,
  faWhatsapp as fabWhatsapp,
  faSnapchatGhost as fabSnapchatGhost,
} from '@fortawesome/free-brands-svg-icons'

config.autoAddCss = false

library.add(
  fasCut,
  fasAngleDown,
  fasSearch,
  fasReply,
  fasUserCheck,
  fasChevronLeft,
  fasShoppingBag,
  fasAngleUp,
  fasCameraAlt,
  fasUserCrown,
  fasShoppingBasket,
  fasMinus,
  fasAngleLeft,
  fasPlus,
  fasPhoneAlt,
  fasCheck,
  fasHomeLgAlt,
  fasCartArrowDown,
  fasStar,
  fasArrowRight,
  fasTimes,
  fasCheckCircle,
  fasCar,
  fasTruck,
  fasMotorcycle,
  fasTractor,
  fasTruckMonster,
  fasBicycle,
  fasExclamation,
  fasPhotoVideo,
  fasExclamationTriangle,
  fasExclamationCircle,
  fasClock,
  fasChevronCircleRight,
  fasHeart,
  fasBadgeCheck,
  fasPlay,
  fasSlidersH,
  fasBuilding,
  fasBriefcase,
  fasMapMarkerAlt,
  fasFileAlt,
  fasReceipt,
  fasCalendar,
  fasCrown,
  fasEuroSign,
  fasFileInvoice,
  fasTags,
  fasPercentage,
  fasHeadset,
  fasMapMarkedAlt,
  fasBullhorn,
  fasEllipsisH,
  fasUsers,
  fasWrench,
  fasChevronRight,
  fasTrashAlt,
  fasIdCard,
  fasChevronUp,
  fasChevronDown,
  fasLink,
  fasShareAlt,
  fasLongArrowAltLeft,
  fasExchangeAlt,
  fasCog,
  fasWallet,
  fasCoins,
  fasImage,
  fasMobileAlt,
  fasTag,
  fasShoppingCart,
  fasLightbulb,
  fasCircle,
  fasBell,
  fasTimesCircle,
  fasBrowser,
  fasArrowAltCircleRight,
  fasDownload,
  fasInfoCircle,
  fasLockAlt,
  fasCommentsAlt,
  fasUserHeadset,
  fasTruckLoading,
  fasTrash,
  fasPencil,
  fasMapMarkerCheck,
  fasMapMarkerQuestion,
  fasEnvelope,
  fasEnvelopeOpen,
  fasArrowCircleUp,
  fasCalendarTimes,
  fasBox,
  fasPercent,
  fasSave,
  fasSpinner,
  fasCartPlus,
  fasSlidersV,
  fasInfoSquare,
  fasCopy,
  fasCogs,
  fasBoxFull,
  fasPaperPlane,
  fasCreditCardFront,
  fasShippingFast,
  fasCommentAlt,
  fasPaperclip,
  fasToolbox,
  fasLock,
  fasRepeat,
  fasTrophyAlt,
  fasGarageOpen,
  fasFileSignature,
  fasAngleRight,
  fasLocation,
  fasClone,
  fasClipboardList,
  fasFilePdf,
  fasEye,
  fasFileInvoiceDollar,
  fasUndo,
  fasList,
  fasMap,
  fasPhone,
  fasTh,
  fasLocationArrow,
  fasArrowUp,
  fasChartLine,
  fasWarehouse,
  fasSearchPlus,
  fasArrowLeft,
  fasRedo,
  fasFile,
  fasBolt,
  fasLightbulbOn,
  fasThumbtack,
  fasUnlink,
  fasVolumeUp,
  fasVolumeMute
)

library.add(fadUserCrown, fadCheckCircle, fadExclamationTriangle)

library.add(
  falTrophyAlt,
  falShippingFast,
  falMotorcycle,
  falAngleRight,
  falBell,
  falShieldCheck,
  falLock,
  falUndo,
  falAngleLeft,
  falArrowLeft,
  falLongArrowLeft,
  falSearchPlus,
  falChevronLeft,
  falLifeRing,
  falPlayCircle,
  falInfoCircle,
  falTimes,
  falPlus,
  falCircle,
  falMinus,
  falChevronRight,
  falQuestionCircle,
  falAngleDown,
  falAngleUp,
  falChevronDown,
  falCheck,
  falBars,
  falBolt,
  falTools,
  falUserCheck,
  falUserCircle,
  falSearch,
  falShoppingBag,
  falStore,
  falUniversity,
  falImage,
  falPercentage,
  falRedoAlt,
  falPlusCircle,
  falMinusCircle,
  falExternalLink,
  falPencil,
  falExclamationTriangle,
  falHandPointDown,
  falHeart,
  falPlay,
  falTruck,
  falTractor,
  falCar,
  falLightbulbOn,
  falLightbulb,
  falLightbulbSlash,
  falExternalLinkAlt,
  falCarSide,
  falCalendarAlt,
  falClock,
  falSlidersH,
  falSortAmountDown,
  falThLarge,
  falListUl,
  falEraser
)

library.add(
  fabFacebookSquare,
  fabFacebookF,
  fabInstagram,
  fabGoogle,
  fabPaypal,
  fabCcVisa,
  fabCcPaypal,
  fabCcMastercard,
  fabCcApplePay,
  fabTiktok,
  fabYoutube,
  fabTwitter,
  fabWhatsapp,
  fabSnapchatGhost
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
